import React from 'react';

import classNames from 'classnames';

import BarsIcon from 'Assets/icons/bars-2.svg';
import CalendarIcon from 'Assets/icons/calendar.svg';
import ChartBarIcon from 'Assets/icons/chart-bar.svg';
import ListIcon from 'Assets/icons/list.svg';

/**
 * IB-700 — Plan tab view switcher (Register · Gantt · Kanban · Calendar).
 *
 * Timeline was dropped per the v14 prototype. Calendar is a live view — Dave supplied its reference
 * design (a month grid plotting the procurement key dates), so it is wired up like the other views.
 */
export const PLAN_VIEWS = {
    REGISTER: 'register',
    GANTT: 'gantt',
    KANBAN: 'kanban',
    CALENDAR: 'calendar',
};

const VIEWS = [
    { id: PLAN_VIEWS.REGISTER, label: $t('Register'), Icon: ListIcon },
    { id: PLAN_VIEWS.GANTT, label: $t('Gantt'), Icon: ChartBarIcon },
    { id: PLAN_VIEWS.KANBAN, label: $t('Kanban'), Icon: BarsIcon },
    { id: PLAN_VIEWS.CALENDAR, label: $t('Calendar'), Icon: CalendarIcon },
];

const ViewSwitcher = ({ activeView, onChange }) => (
    <div className="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-lg tw-bg-charcoal-10 tw-p-1">
        {VIEWS.map(({ id, label, Icon, comingSoon }) => {
            const isActive = activeView === id;

            return (
                <button
                    key={id}
                    type="button"
                    disabled={comingSoon}
                    title={comingSoon ? $t('Coming soon') : undefined}
                    onClick={() => !comingSoon && onChange(id)}
                    className={classNames(
                        'tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-md tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-transition-colors',
                        {
                            'tw-bg-charcoal tw-text-white': isActive,
                            'tw-text-charcoal-75 hover:tw-text-charcoal': !isActive && !comingSoon,
                            'tw-text-charcoal-25 tw-cursor-not-allowed': comingSoon,
                        },
                    )}
                >
                    <Icon className="tw-w-3.5 tw-h-3.5" />
                    {label}
                </button>
            );
        })}
    </div>
);

export default ViewSwitcher;
